// Auto-generated file - do not edit manually
export const gitVersion = {
  "dirty": false,
  "raw": "fd4d942",
  "hash": "fd4d942",
  "distance": null,
  "tag": null,
  "semver": null,
  "suffix": "fd4d942",
  "semverString": null
};
export default gitVersion;
